/**
 * Formats Turkish phone numbers
 * Auto-prepends 0 if missing
 * Converts 5XXXXXXXXX to 05XX XXX XX XX
 *
 * @param {string} value - Raw phone input
 * @returns {string} Formatted phone: 0XXX XXX XX XX
 */
export const formatPhoneNumber = (value) => {
  // Remove all non-digits
  let cleanValue = value.replace(/\D/g, '');

  // If user starts with 5, automatically add 0 at the beginning
  if (cleanValue.length > 0 && cleanValue[0] === '5') {
    cleanValue = '0' + cleanValue;
  }

  // Ensure it starts with 0
  if (cleanValue.length > 0 && cleanValue[0] !== '0') {
    cleanValue = '0' + cleanValue;
  }

  // Limit to 11 digits (Turkish phone format)
  cleanValue = cleanValue.slice(0, 11);

  // Apply Turkish phone number format: 0XXX XXX XX XX
  if (cleanValue.length === 0) return '';
  if (cleanValue.length <= 4) return cleanValue;
  if (cleanValue.length <= 7) return `${cleanValue.slice(0, 4)} ${cleanValue.slice(4)}`;
  if (cleanValue.length <= 9) return `${cleanValue.slice(0, 4)} ${cleanValue.slice(4, 7)} ${cleanValue.slice(7)}`;
  return `${cleanValue.slice(0, 4)} ${cleanValue.slice(4, 7)} ${cleanValue.slice(7, 9)} ${cleanValue.slice(9, 11)}`;
};

/**
 * Cleans formatted phone number for API submission
 * Removes spaces and non-digit characters
 *
 * @param {string} formattedPhone - Formatted phone: 0XXX XXX XX XX
 * @returns {string} Clean digits: 05XXXXXXXXX
 */
export const cleanPhoneNumber = (formattedPhone) => {
  return formattedPhone ? formattedPhone.replace(/\D/g, '') : '';
};
